import { withErrReport } from '../../lib/utils';

function MaxWidth({ data: { maxWidth } }) {
  const style = document.createElement('style');
  style.innerHTML = `\n
  body, .editor-preview-components {
    max-width: ${maxWidth}px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }`;
  style.className = 'impage-material-plugin-max-width';
  document.head.appendChild(style);
}

export default withErrReport(MaxWidth);
